export default {
  ReportParam: {
    UnitMoney: 'Đơn vị tính',
    DataYear: 'Kỳ báo cáo',
    SubmitEstimate: 'Lần nộp',
    Chapter : 'Chương',
    ViewWith: 'Xem theo',
  }
};